import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen bg-background-50 overflow-hidden">
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen w-full px-4 md:px-6 pt-20 pb-16">
        {/* Top label bar */}
        <div className="flex items-center gap-3 mb-8">
          <div className="flex items-center gap-2 px-3 py-1.5 bg-accent-100/70 rounded-full">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-information-line text-xs text-accent-700"></i>
            </div>
            <span className="text-xs font-medium text-accent-700">Kompletny przewodnik 2026</span>
          </div>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 hover:bg-background-200 transition-colors cursor-pointer"
            title="Otwórz platformę"
          >
            <i className="ri-external-link-line text-sm text-foreground-600"></i>
          </a>
        </div>

        {/* H1 Title */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl xl:text-8xl text-center text-foreground-950 leading-[1.08] max-w-4xl mx-auto">
          usfansspreadsheet
          <br />
          <span className="text-foreground-700">Kompletny przewodnik</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-6 text-base md:text-lg text-foreground-600 text-center max-w-xl">
          Sprawdź najbezpieczniejsze i najskuteczniejsze rozwiązania związane z usfansspreadsheet. Porównania, poradniki i wszystko, co musisz wiedzieć.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-foreground-900 rounded-full hover:bg-foreground-800 transition-all text-center whitespace-nowrap cursor-pointer flex items-center gap-2 justify-center"
          >
            <span>Zobacz pełny przewodnik</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-800 bg-background-50 border border-foreground-300/50 rounded-full hover:border-foreground-500 transition-all text-center whitespace-nowrap cursor-pointer flex items-center gap-2 justify-center"
          >
            <span>Otwórz platformę</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>

      {/* Bottom image */}
      <div className="w-full h-[300px] md:h-[420px] relative -mt-10">
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent z-10"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20two%20large%20monitors%20showing%20colorful%20data%20dashboards%2C%20white%20desk%20with%20neat%20accessories%2C%20indoor%20plants%2C%20bright%20natural%20daylight%20from%20large%20windows%2C%20clean%20professional%20office%2C%20warm%20morning%20atmosphere%2C%20editorial%20photography&width=1600&height=900&seq=hero-bg-v2-01&orientation=landscape"
          alt="usfansspreadsheet - nowoczesne miejsce pracy"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
    </section>
  );
}